import {orderBy, pick} from 'lodash'
import React from 'react'
import Modal from 'react-modal'
import TabBar from './tab-bar'
import Text from 'react-text'
import {Context} from 'context'
import {isEmptyOrWhiteSpace} from 'helpers/utils'
import GroupsStep from './groups-step'
import DateStep from './date-step'
import {scheduleAssessment} from '../../context/post'
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import CircularProgress from '@mui/material/CircularProgress'

import './index.styl'

function Buttons ({left, right}) {
  return (
    <div className="buttons" style={{display: "flex"}}>
      <div style={{flexGrow: 1}} />
      <button disabled={!left.enabled} className={left.label} onClick={left.onClick}>
        {left.loading && <CircularProgress />}
        {!left.loading && <Text id={`${left.label}_label`} />}
      </button>
      <button disabled={!right.enabled} className={right.label} onClick={right.onClick}>
        {right.loading && <CircularProgress />}
        {!right.loading && <Text id={`${right.label}_label`} />}
      </button>
    </div>
  )
}

export default class ScheduleAssessment extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const setState = this.setState.bind(this)
    this.state = {
      start: props.start || new Date(),
      finish: props.finish || new Date(),
      maxTime: 3600,
      message: props.message || "",
      activeTab: props.activeTab,
      selectedGroup: props.selectedGroup,
      studentList: props.studentList || [],
      selectedStudents: props.selectedStudents || [],
      isOpen: true,
      setState
    }
  }


  render () {

    const context = this.context
    const {setState, activeTab, isOpen} = this.state
    const {assessment: assessmentId, assessmentView} = context
    const assessment = assessmentView.find(({id}) => id == assessmentId) || {}

    const markAssessmentAsAssigned = async () => {
      const assessmentView = context.assessmentView.map(assessment => (assessment.id != assessmentId ? assessment : {...assessment, assigned: true}))
      context.updateState({sending: {scheduleAssessment: {$set: false}}})
      context.setState({assessmentView}, close)
    }

    const save = async () => {
      if (context.sending.scheduleAssessment) return
      console.log('Sending schedule')
      await context.updateState({sending: {scheduleAssessment: {$set: true}}})
      return scheduleAssessment({
        id: assessment.id,
        title: assessment.name,
        course: this.state.selectedGroup.course,
        maxTime: this.state.maxTime,
        start: this.state.start,
        finish: this.state.finish,
        language: context.languageId,
        students: this.state.selectedStudents,
        action: context.action,
        message: this.state.message,
      }).then(markAssessmentAsAssigned)
    }

    const previous = () => setState({activeTab: 'groups'})
    const next = () => setState({activeTab: 'date'})
    const close = () => setState({isOpen: false})
    const navigateOut = () => context.navigate({}, context.match.path.replace(/\/:action.*$/,''), {preserveQuery: true})
    const canSave = this.state.selectedStudents.length > 0 && !isEmptyOrWhiteSpace(this.state.message) && !context.sending.scheduleAssessment

    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="schedule-assessment-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="schedule-assessment">
            <div className="title">
              <div className="label">
                <Text id="assessment_title" />
                {`: ${assessment.name}`}
              </div>
              <div className="close" onClick={() => close()}>
                <FontAwesomeIcon icon={faTimesCircle} />
              </div>
            </div>
            <TabBar {...{activeTab, setState}} />
            <div className="tab-content">
              {activeTab == 'groups' && (
                <React.Fragment>
                  <GroupsStep {...pick(this.state, ['selectedGroup', 'studentList', 'selectedStudents', 'setState'])} />
                  <Buttons
                    left={{label: 'cancel', onClick: close, enabled: true}}
                    right={{label: 'continue', onClick: next, enabled: true}}
                  />
                </React.Fragment>
              )}
              {activeTab == 'date' && (
                <React.Fragment>
                  <DateStep {...pick(this.state, ['start', 'finish', 'maxTime', 'setState', 'message'])} />
                  <Buttons
                    left={{label: 'back', onClick: previous, enabled: true}}
                    right={{label: 'save', onClick: save, enabled: canSave}}
                  />
                </React.Fragment>
              )}
            </div>
          </div>
        </Modal>
    )
  }
}
